import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

/** */
/** */
// import SplitCarousel from "vue-split-carousel";
// App.use(SplitCarousel);
// import { Navigation, Pagination } from "swiper";

// import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
// SwiperCore.use([Navigation, Pagination]);
// import "swiper/swiper-bundle.css";
import axios from "axios";
let apiKey = "194d8a67379374e13e12c99420c19098";
Vue.prototype.$axios = axios;
Vue.prototype.$apiKey = apiKey;
/** */
import api from "@/db/api";
import MAIN_API from "@/components/Movie/api/movie";
Vue.prototype.$http = api;
Vue.prototype.$MAIN_API = MAIN_API;
import Carousel3d from "vue-carousel-3d";

Vue.use(Carousel3d);
/** */
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
